import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	PostSurgeryConfirm,
	PostSurgeryConfirmParams,
} from 'domain/usecases/private/booking-flow/surgery/post-surgery-confirm';

export class RemotePostSurgeryConfirm implements PostSurgeryConfirm {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<unknown>,
	) {}

	async post(params: PostSurgeryConfirmParams): Promise<unknown> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
